import React, { useState, useEffect } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import ValidView from "../../../components/app/validView.js";
import Spinner from "react-bootstrap/Spinner";
import ModalExportExcel from "../../../components/tables/ModalExportExcel.js";
import CustomHeader from "./CustomHeader.js";
import { searchUtils } from "../../../components/tables/searchUtils.js";
import { FaAddressBook } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import dateToISOString from '../../../components/app/dateToISOString';

const InbursaUsersLogin = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const [resetGridTable, setResetGridTable] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [columnsGrid, setColumnsGrid] = useState([]);

  const [show_excel, setshow_excel] = useState(false);
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);

  const handleClose_excel = () => setshow_excel(false);

  const [objFilter, setObjFilter] = useState([]);
  const [stringFilter, setStringFilter] = useState('');
  const { allowWrite, allowView, userToken } = ValidView("InbursaUsersLogin");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);
  const [viewType, setViewType] = useState('usersLoginGrouped');

  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

  const [dates, setDates] = useState({
    startDate: new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999),
  });

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay, objFilter }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);

  const modal_excel = () => {
    setshow_excel(true);
  };

  const modalDetail = (codeItem, typeView) => {
    setShow(true);
  };

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };
    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
  };

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);

    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const dateRangeRegex = /range=createdAt\|([^|]+)\|([^|]+)/;

    const startDateISOString = dateToISOString(dates.startDate);
    const endDateISOString = dateToISOString(dates.endDate, true);

    const updatedSearchText = stringFilter.includes("range=createdAt")
      ? stringFilter.replace(dateRangeRegex, `range=createdAt|${startDateISOString}|${endDateISOString}`)
      : `${stringFilter}&range=createdAt|${startDateISOString}|${endDateISOString}`;

    let urlBaseFetch = process.env.REACT_APP_NERTHUS_API_URL + `/inbursa/${viewType}?page=` + (page) + '&perPage=' + pageSize;

    const response = await fetch(urlBaseFetch + updatedSearchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  const handlerChangeView = () => {
    setPage(1);

    if (viewType === 'usersLoginGrouped') {
      setViewType('inbursaUsersLogin');
    } else {
      setViewType('usersLoginGrouped');
    }

    setResetGridTable(!resetGridTable);
  };

  const urlBaseExport = (stringFilter) ? `/inbursa/${viewType}/exportToExcel?page=1&perPage=9999`
    : `/inbursa/${viewType}/exportToExcel?page=1&perPage=9999&range=createdAt|${dateToISOString(dates.startDate)}|${dateToISOString(dates.endDate, true)}`;

  let addButton = (<> <Button type="button" className="btn btn-warning" alt="Create" size="sm" onClick={() => { handlerChangeView(); }}> <FaAddressBook />
    {viewType === 'usersLoginGrouped' ? ' Detail ' : ' Grouped '}
  </Button></>);

  return (
    <>
      <div className="tableWrapper">
        {!rowsLoading
          ? (<Spinner animation="border" role="status" variant="secondary" >
            <span className="visually-hidden">Loading...</span>
          </Spinner>) : (<>
            <GridTable
              key={resetGridTable}
              columns={columnsGrid}
              rowIdField={'code'}
              onRowsRequest={onRowsRequest}
              isLoading={isLoading}
              pageSizes={rowsPerPageArray}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
              onPageChange={OnPageChange}
              selectedRowsIds={selectedRowsIds}
              onSelectedRowsChange={setSelectedRowsIds}
              showSearch={false}
              showColumnVisibilityManager={false}
              highlightSearch={false}
              minSearchChars={3}
              components={{ Header: (props) => <CustomHeader {...props} dates={dates} setDates={setDates} modal_excel={modal_excel} setStringFilter={setStringFilter} addButton={addButton} objFilter={objFilter} /> }}
            />
          </>)}
      </div>
      <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'UsersLogin.xlsx'} />
    </>
  );
};

export default InbursaUsersLogin;